import { useMemo } from "react";
import { Resource, RESOURCES, ResourceType } from "routers/constant";
import { MENUITEMS } from "./Menu";
import { getResouceFromPath } from "hook/useCurrentResource";
import { USER_ROLE } from "models/user-role";
import { useUserProfile } from "hook/useUserProfile";

type AvaiableUrl = {
  [key in USER_ROLE]: Resource[];
};

type ResourceCan = {
  [key in string]: Partial<{
    [key in ResourceType]: boolean;
  }>;
};
type Can = {
  [key in USER_ROLE]: ResourceCan;
};

const AVAIABLE_URLS: AvaiableUrl = {
  [USER_ROLE.DIEU_HANH]: RESOURCES,
  [USER_ROLE.NGUOI_DUNG]: RESOURCES,
  [USER_ROLE.ADMIN]: RESOURCES,
};

const getRolePermissions = (role: USER_ROLE): ResourceCan => {
  const roleResource = AVAIABLE_URLS[role];
  return RESOURCES.reduce((acc, cur) => {
    const can = roleResource.includes(cur);
    return {
      ...acc,
      [cur]: {
        [ResourceType.CREATE]: can,
        [ResourceType.LIST]: can,
        [ResourceType.DELETE]: can,
        [ResourceType.DETAIL]: can,
        [ResourceType.EDIT]: can,
      },
    };
  }, {});
};

const CAN: Can = {
  [USER_ROLE.NGUOI_DUNG]: {
    ...getRolePermissions(USER_ROLE.NGUOI_DUNG),
  },
  [USER_ROLE.ADMIN]: getRolePermissions(USER_ROLE.ADMIN),
  [USER_ROLE.DIEU_HANH]: getRolePermissions(USER_ROLE.DIEU_HANH),
};

export const useMenu = () => {
  const { data } = useUserProfile();

  const isAdmin = useMemo(
    () => data?.userRole?.name === USER_ROLE.ADMIN,
    [data]
  );

  const isDieuHanhVien = useMemo(
    () => data?.userRole?.name === USER_ROLE.DIEU_HANH,
    [data]
  );

  const userRole = useMemo(() => {
    if (isAdmin) {
      return USER_ROLE.ADMIN;
    }
    if (isDieuHanhVien) {
      return USER_ROLE.DIEU_HANH;
    }
    return USER_ROLE.NGUOI_DUNG;
  }, [isAdmin, isDieuHanhVien]);

  const menus = useMemo(() => {
    const urls = AVAIABLE_URLS[userRole];
    if (userRole === USER_ROLE.ADMIN) {
      return MENUITEMS;
    }
    return MENUITEMS.map((menu) => ({
      ...menu,
      Items: menu.Items.filter(({ path }) =>
        !path || urls.includes(getResouceFromPath(path))
      ),
    })).filter((x) => x.Items.length);
  }, [userRole]);

  const can = useMemo(() => {
    return CAN[userRole];
  }, [userRole]);

  return {
    menus,
    userRole,
    can,
  };
};
